import React, { useState, useMemo, useEffect, useRef } from "react";
import toast from "react-hot-toast";
// import api from "../api/Api";
import api, { IMAGE_BASE_URL } from "../api/Api.js";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import "./ConfirmSalaryPage.css";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
const months = [
  "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December",
];

const PrepareSalaryPage = () => {
   const navigate = useNavigate();
  const today = new Date();
  const { month, year } = useParams();
  

  // const [selectedMonth, setSelectedMonth] = useState(today.getMonth());
  // const [selectedYear, setSelectedYear] = useState(today.getFullYear());



const initialMonth = month ? Number(month-1) : new Date().getMonth();
const initialYear = year ? Number(year) : new Date().getFullYear();

// checkbox state (idx based)
const [checkedRows, setCheckedRows] = useState({});
const [checkAll, setCheckAll] = useState(false);
  // const [selectedMonth, setSelectedMonth] = useState(today.getMonth());
  // const [selectedYear, setSelectedYear] = useState(today.getFullYear());
  const [selectedMonth, setSelectedMonth] = useState(initialMonth);
  const [selectedYear, setSelectedYear] = useState(initialYear);
  const [saveAttendanceList, setSaveAttendanceList] = useState([]);
  const [showConfirm, setShowConfirm] = useState(false);
 const [submitting, setSubmitting] = useState(false);
 const [driverData, setDriverData] = useState([]);
 const [showModal, setShowModal] = useState(false);
 const [selectedDriverRegno, setSelectedDriverRegno] = useState(null);
 const tableRef = useRef();
  /* ================= FETCH SALARY DATA ================= */


 const handleFileUpload = (e) => {
  const file = e.target.files[0];
  if (!file) return;

  setSelectedFile(file);
};



//submit area end//

  useEffect(() => {
    fetchPreparedSalary();
    fetchDriverData();
  }, [selectedMonth, selectedYear]);

  const fetchPreparedSalary = async () => {
    try {
      const resp = await api.get(
        `/adminmodSalary/getPreperSalayData/${selectedMonth + 1}/${selectedYear}`
      );
      console.log("FETCHED SALARY DATA:", resp.data);
      setSaveAttendanceList(resp.data?.data || []);
    } catch (err) {
      toast.error("Failed to load salary data");
    }
  };

  /* ================= SALARY DATA EXTRACTION ================= */
  // const salaryObj = saveAttendanceList?.[0]?.salary_data || {};

  // const salaryStatus = saveAttendanceList?.[0]?.conf_sts;

  // const salaryData = Array.isArray(salaryObj?.drivers)
  //   ? salaryObj.drivers
  //   : [];


    const salaryObj = useMemo(() => {
  const raw = saveAttendanceList?.[0]?.salary_data;

  if (!raw) return {};

  try {
    return typeof raw === "string" ? JSON.parse(raw) : raw;
  } catch (err) {
    console.error("Invalid salary_data JSON", err);
    return {};
  }
}, [saveAttendanceList]);

const salaryStatus = saveAttendanceList?.[0]?.conf_sts;

const salaryData = Array.isArray(salaryObj?.drivers)
  ? salaryObj.drivers
  : [];
    

  /* ================= YEAR LIST ================= */
  const years = [
    today.getFullYear() - 2,
    today.getFullYear() - 1,
    today.getFullYear(),
  ];

  /* ================= PREPARE SALARY ================= */
const handlePrepareSalaryConfirm = async () => {
  try {
    const salary_id = saveAttendanceList[0]?.salary_id;

    if (!salary_id) {
      toast.error("Salary ID not found");
      return;
    }

    await api.post("/adminmodSalary/confirm/salary/submit", {
      salary_id: salary_id,
    });

    toast.success("Salary Confirmed Successfully");
    fetchPreparedSalary();

  } catch (err) {
    toast.error(
      err.response?.data?.message ||
      "Confirm Salary already prepared for this month"
    );
  }
};

const handlePrepareSalary = async () => {
  try {

    
const payload = salaryData
      .filter((_, idx) => checkedRows[idx]) // ✅ ONLY SELECTED ROWS
      .map((row, idx) => {
      
      return {
         salary_id : saveAttendanceList[0]?.salary_id,
        driver_regno: row.driver_regno,
        conform_status: '1',
      };
 });
    // await api.post("/adminmodSalary/confirm/salary/submit", {
    //   salary_id: salary_id,
    // });

       await api.post("/adminmodSalary/confirm/salary/add", { records: payload });

    toast.success("Salary Confirmed Successfully");
    fetchPreparedSalary();
navigate(`/salary/salary-slip/${selectedMonth + 1}/${selectedYear}`);
  } catch (err) {
    toast.error(
      err.response?.data?.message ||
      "Confirm Salary already prepared for this month"
    );
  }
};






//CHECK ALL AREA START//
const handleRowCheck = (idx) => {
  setCheckedRows((prev) => {
    const updated = {
      ...prev,
      [idx]: !prev[idx],
    };

    // agar koi ek bhi unchecked hai → uncheck ALL
    const allChecked =
      salaryData.length > 0 &&
      salaryData.every((_, i) => updated[i]);

    setCheckAll(allChecked);

    return updated;
  });
};

const handleCheckAll = () => {
  const newValue = !checkAll;
  setCheckAll(newValue);

  const updated = {};
  salaryData.forEach((_, idx) => {
    updated[idx] = newValue;
  });

  setCheckedRows(updated);
};

//CHECK ALL AREA END//

//CHECK ALL DRIVER START///
const fetchDriverData = async () => {
    try {
      const res = await api.get("/adminmod/getDriverData");
      setDriverData(res.data?.data || []);
    } catch {
      toast.error("Failed to load driver details");
    }
  };
  const totalConfirm = salaryData.filter(
  row => Number(row.conform_status) === 1
).length;
//CHECK ALL DRIVER END//
//CHECK PREPARE TABLE  AREA START//
const handleDelete = async (salary_id,driver_reg) => {
  if (!salary_id || !driver_reg) {
    toast.error("Required data missing");
    return;
  }

  try {
    const res = await api.post("/adminmod/deletePrepareTable", {
      salary_id: salary_id,
      driver_reg: driver_reg,
    });

    if (res.data?.success) {
      toast.success(res.data.message || "Deleted successfully");
       fetchPreparedSalary();
    fetchDriverData();
    } else {
      toast.error(res.data.message || "Delete failed");
    }
  } catch (error) {
    console.error("DELETE ERROR:", error);
    toast.error("Server error");
  }
};

//CHECK PREPARE TABLE  AREA END//

  return (
    <div>
      {/* DELETE MODEL AREA START */}
{showModal && (
 <div className="modal fade show d-block" tabIndex="-1" style={{ background: "rgba(0,0,0,0.5)" }}>
  <div className="modal-dialog modal-dialog-centered">
    <div className="modal-content shadow-lg rounded-4">

      {/* HEADER */}
      <div className="modal-header border-0 justify-content-center">
        <div
          className="d-flex align-items-center justify-content-center rounded-circle bg-danger text-white"
          style={{ width: 60, height: 60 }}
        >
          <i className="fa fa-trash fs-4"></i>
        </div>
      </div>

      {/* BODY */}
      <div className="modal-body text-center px-4">
        <h5 className="fw-bold mb-2">Delete Confirmation</h5>
        <p className="text-muted mb-0">
          Are you sure you want to delete this record?
        </p>
      </div>

      {/* FOOTER */}
      <div className="modal-footer border-0 justify-content-center gap-2 pb-4">
        <button
          className="btn btn-outline-secondary px-4"
          onClick={() => setShowModal(false)}
        >
          No, Cancel
        </button>

        <button
          className="btn btn-danger px-4"
          onClick={() => {
            handleDelete(saveAttendanceList[0]?.salary_id,selectedDriverRegno);
            setShowModal(false);
          }}
        >
          Yes, Delete
        </button>
      </div>

    </div>
  </div>
</div>

)}

{/* DELETE MODEL AREA END */}
      {/* PAGE TITLE */}
      <div className="pageTitlesalary" style={{display:"flex", justifyContent:"space-between"}}>
      <div>
        <h2 className="title1">
          Confirm Salary – {months[selectedMonth]} {selectedYear}
        </h2>
      </div>
      
      {/* Month & Year Filters */}
        <div className="controls" style={{marginBottom:"1px"}}>
          <label>Month:</label>
          <select
            value={selectedMonth}
            onChange={(e) => setSelectedMonth(Number(e.target.value))}
          >
            {months.map((m, i) => (
              <option key={i} value={i}>
                {m}
              </option>
            ))}
          </select>
              <label>Year:</label>
          <select
            value={selectedYear}
            onChange={(e) => setSelectedYear(Number(e.target.value))}
          >
            {years.map((y) => (
              <option key={y} value={y}>
                {y}
              </option>
            ))}
          </select>
          {/* submit area start */}
              {salaryData.length != 0 && (
      <>
         {driverData.length === totalConfirm && salaryStatus !=2 && (
          <div style={{textAlign:"center"}}>
            <button
            className="btn btn-success"
            disabled={submitting}
            onClick={() => {
                    handlePrepareSalaryConfirm();
                  }}
            >
            {submitting ? (
            "Submitting..."
            ) : (
            <>
            Process for Salary Slip  {months[selectedMonth]} {selectedYear}
            </>
            )}

            </button>
          </div>

         )}
      
            <div>  
            {driverData.length != totalConfirm && salaryStatus !=2 && (
            <button
            className="btn btn-success"
            disabled={submitting}
            onClick={() => setShowConfirm(true)}
            >
            {submitting ? (
            "Submitting..."
            ) : (
            <>
            Confirm Salary of {months[selectedMonth]} {selectedYear}
            </>
            )}

            </button>
            )}
           
            </div>
            </>
    )}
          {/* submit area end */}
        </div>
    </div>
    <table className="salary-table" style={{ width: "100%" }}>
<thead>
<tr>
<th className="sticky-col" style={{backgroundColor:"red", color:"#fff"}}>Note</th>
<th className="sticky-col">Total Driver - <span>{driverData.length}</span></th>
<th className="sticky-col">Salary Prepared for {months[selectedMonth]} {selectedYear} - <span>{salaryData.length} Driver(s) </span></th>
<th className="sticky-col">Salary Confirmed for {months[selectedMonth]} {selectedYear} - <span>{totalConfirm} Driver(s) </span></th>
</tr>
</thead>
</table>
      <div className="driverAttendance-wrapper">
        

        {/* ALREADY PREPARED MESSAGE */}
        

          

        {salaryStatus === 2 && (
          <div>
            <div style={{display:"flex", justifyContent:"space-between"}} className="alert alert-warning">
          <div >
            Salary Preparation process completed Successfully. No further modifications allowed
          </div>
          
          </div>
          </div>
        )}

        {/* DEBUG (OPTIONAL) */}
        {/* <pre>{JSON.stringify(saveAttendanceList, null, 2)}</pre> */}

        {/* Salary Table */}
        <div className="abstractAttendance-scroll-new-con1">
          <table className="salary-table" style={{ width: "100%" }}  ref={tableRef}>
            <thead>
              <tr>
                     <th className="sticky-col" rowSpan="2"  id="prepareSalary">All
  <input
    type="checkbox"
    checked={checkAll}
    onChange={handleCheckAll}
  />
</th>
                <th rowSpan="2"  id="prepareSalary">Sl No.</th>
                <th rowSpan="2"  id="prepareSalary">Driver Name</th>
                <th rowSpan="2"  id="prepareSalary">Driver ID</th>
                <th rowSpan="2"  id="prepareSalary">Salary Per Month</th>
                <th rowSpan="2"  id="prepareSalary">Present (Days)</th>
                <th rowSpan="2"  id="prepareSalary">Leave (Days)</th>
                <th rowSpan="2" id="prepareSalary">Paid Leaves (Days)</th>
                 <th rowSpan="2" id="prepareSalary">Salary Days</th>
                <th rowSpan="2"  id="prepareSalary">Leave Deduction</th>
                <th rowSpan="2"  id="prepareSalary">Extra Allowance</th>
                <th rowSpan="2"  id="prepareSalary">Gross Salary</th>
                <th colSpan="5"  id="prepareSalary" style={{display:"none"}}>Other Deductions</th>
                <th rowSpan="2"  id="prepareSalary">Total Deduction</th>
                <th rowSpan="2"  id="prepareSalary">Net Salary</th>
                <th rowSpan="2"  id="prepareSalary">Bank Account Details</th>
                <th rowSpan="2"  id="prepareSalary">Payment Mode</th>
                <th rowSpan="2"  id="prepareSalary">Comments</th>
                {salaryStatus !== 2 && (
                <th rowSpan="2"  id="prepareSalary">Action</th>
                )}
              </tr>
              <tr>
                <th id="prepareSalary" style={{display:"none"}}>Adv</th>
                <th  id="prepareSalary" style={{display:"none"}}>Loan</th>
                <th  id="prepareSalary" style={{display:"none"}}>LIC</th>
                <th  id="prepareSalary" style={{display:"none"}}>D1</th>
                <th  id="prepareSalary" style={{display:"none"}}>D2</th>
              </tr>
            </thead>

            <tbody>
              {salaryData.length === 0 && (
                <tr>
                  <td colSpan="18" style={{ textAlign: "center" }}>
                    No salary data found
                  </td>
                </tr>
              )}
{/* <pre>
  {JSON.stringify(salaryData, null, 2)}
</pre> */}

              {salaryData.map((row, idx) => (
             
                <tr key={idx}>
                                <td>

  <input
    type="checkbox"
  
    checked={
      Number(row.conform_status) === 1 || !!checkedRows[idx]
    }
    disabled={Number(row.conform_status) === 1}
    onChange={() => handleRowCheck(idx)}
  />
</td>

                  <td>{idx + 1}</td>
                  <td>{row.driver_name}</td>
                  <td>{row.driver_regno}</td>
                   <td>{row.salary_in_month}</td>
                  <td>{row.worked_days}</td>
                  <td>{row.leave_days}</td>
                  <td>{row.paid_leave}</td>
                  <td>{row.total_salary_process}</td>
                  <td>{row.leave_deduction}</td>
                  <td>{row.extra_allowance}</td>
                  <td>{row.gross_salary}</td>

                  <td style={{display:"none"}}>{row.deductions?.adv}</td>
                  <td style={{display:"none"}}>{row.deductions?.loan}</td>
                  <td style={{display:"none"}}>{row.deductions?.lic}</td>
                  <td style={{display:"none"}}>{row.deductions?.d1}</td>
                  <td style={{display:"none"}}>{row.deductions?.d2}</td>

                  <td>{row.deductions?.total}</td>
                  <td className="net-salary">{row.net_salary}</td>
                  <td>
                  
              
   <span style={{fontWeight:"600"}}>Bank :</span><span> {row.bankname}</span><br/>
      <span style={{fontWeight:"600"}}>Branch :</span><span> {row.bankbranch} </span><br/>
    <span style={{fontWeight:"600"}}>IFSC Code :</span><span> {row.bankifsc}</span><br/>
      <span style={{fontWeight:"600"}}>AC No. :</span><span> {row.accno}</span>

                  </td>
                  <td>{row.paymentModesend === 'bank_payment' ? 'Bank Payment' : 'CASH'}</td>
                  <td>{row.comments}</td>
                  {salaryStatus !== 2 && (
                   <td>             <button
  className="btn btn-danger btn-sm"
  onClick={() => {
    setSelectedDriverRegno(row.driver_regno);
    setShowModal(true);
  }}
  style={{ marginLeft: "5px" }}
>
  <i className="fa fa-trash" aria-hidden="true"></i>
</button></td>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
    {salaryData.length != 0 && (
      <>
         {driverData.length === totalConfirm && salaryStatus !=2 && (
          <div style={{textAlign:"center"}}>
            <button
            className="btn btn-success"
            disabled={submitting}
            onClick={() => {
                    handlePrepareSalaryConfirm();
                  }}
            >
            {submitting ? (
            "Submitting..."
            ) : (
            <>
            Process for Salary Slip  {months[selectedMonth]} {selectedYear}
            </>
            )}

            </button>
          </div>

         )}
      
            <table className="table table-bordered ">
            <thead>

            <tr style={{textAlign:"center"}}>
            <th>  
            {driverData.length != totalConfirm && salaryStatus !=2 && (
            <button
            className="btn btn-success"
            disabled={submitting}
            onClick={() => setShowConfirm(true)}
            >
            {submitting ? (
            "Submitting..."
            ) : (
            <>
            Confirm Salary of  {months[selectedMonth]} {selectedYear}
            </>
            )}

            </button>
            )}
            </th>
            </tr>
            </thead>
            </table>
            </>
    )}
        {/* PREPARE BUTTON */}
        

        {/* CONFIRM MODAL */}
        {showConfirm && (
          <div className="confirm-overlay">
            <div className="confirm-box">
              <h5 style={{ color: "green" }}>Confirm Salary</h5>
              <p>Are you sure you want to Confirm salary?</p>

              <div className="confirm-actions">
                <button
                  className="btn-cancel"
                  onClick={() => setShowConfirm(false)}
                >
                  Cancel
                </button>

                <button
                  className="btn btn-success"
                  onClick={() => {
                    setShowConfirm(false);
                    handlePrepareSalary();
                  }}
                >
                  Yes, Confirm
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default PrepareSalaryPage;
